var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenPiggvar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.76 112.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #757e6b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flounder_and_crab",
    "data-name": "Flounder and crab"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.72,
    cy: 33,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 66.75,
    cy: 45.58,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 69.59,
    cy: 53,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 83.18,
    cy: 39.77,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 71.85,
    cy: 38.83,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.99,
    cy: 38.74,
    r: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 87.57,
    cy: 48.08,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 58.23,
    cy: 50.69,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 73.88,
    cy: 60.48,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 81.84,
    cy: 65.29,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30.2,
    cy: 52.15,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 43.96,
    cy: 56.33,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 63.7,
    cy: 80.84,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 74.34,
    cy: 84.45,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.92,
    cy: 66.34,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 138.62,
    cy: 70.12,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 130.73,
    cy: 61.75,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.71,
    cy: 48.91,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 133.86,
    cy: 46.68,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 95.26,
    cy: 78.71,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 99.97,
    cy: 71.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 91.16,
    cy: 70.39,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 79.81,
    cy: 72.41,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 74.41,
    cy: 67.02,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 87.23,
    cy: 65.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 105.84,
    cy: 69.17,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 111.23,
    cy: 74.7,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 113.66,
    cy: 61.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.75,
    cy: 82.69,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 124.45,
    cy: 53.92,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 127.49,
    cy: 57.51,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 113.3,
    cy: 67.7,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.2,
    cy: 46.6,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 123.11,
    cy: 40.12,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 78.97,
    cy: 77.97,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 63.98,
    cy: 75.2,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 68.23,
    cy: 66.68,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 59.26,
    cy: 60.3,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.33,
    cy: 57.98,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.67,
    cy: 48.54,
    r: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.98,36.84c.08-.06.17-.14.26-.21-.08.07-.17.15-.26.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.23,103.18c-.07,1.04.06,2.12.06,3.18.12.02.24.04.35.06.16-.33.42-.64.45-.98.08-.71.15-1.42.22-2.13-.38-.03-.74-.07-1.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.82,71.55c-.85-1.28-1.68-2.44-2.35-3.72-.99-1.26-1.98-2.52-3.16-3.58-2.05-1.85-4.56-3.1-7.14-4.2-3.49-1.49-7.05-.97-10.63-.9-.66.01-1.33-.44-1.99-.7-.39-.15-.78-.52-1.13-.48-1.09.13-2.28.19-3.2.7-1.46.79-2.93.86-4.5.91-2.08.07-4.16.27-6.23.53-.96.12-1.71,1.44-1.4,2.33.13.35.61.86.88.83,2.41-.25,4.81-.55,7.2-.93,2.73-.43,5.44-1.27,8.18-1.36,2.78-.09,5.59.5,8.39.81.92.1,1.82.3,2.73.44.09.01.18,0,.27,0,.62,0,.92.31,1.11.68.81.17,1.61.55,2.36,1.2,3.41,2.97,7.72,6.43,11.09,10.44.25.14.5.28.75.42-.42-.99-.74-2-.96-3.05-.09-.13-.17-.27-.25-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.13,8.32c.92,2.07,2.06,4.05,3.09,6.06.23-.25.47-.55.75-.89-.24-.45-.5-.89-.66-1.32-.55-1.51-1.73-2.77-2.46-4.22-.6-1.2-.95-2.53-1.38-3.81-.18-.55-.29-1.12-.43-1.69,0,0,0-.01-.01-.02-.12,0-.25.02-.37.03-.09.27-.32.58-.25.79.53,1.7,1,3.44,1.72,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.28,107.52c1.38-.4,2.78-.76,4.13-1.24,1.55-1.26,2.91-2.71,4.31-4.11.59-.91,1.15-1.84,1.68-2.8-.39.47-.97.82-1.82,1.18-.69.29-1.3.74-2.1,1.21-.04-.41-.09-.82-.15-1.23-.31.11-.64.22-.95.32.06.51.11,1.03.16,1.56-1.22.17-2.2.31-2.85.41-.86.52-1.52.91-2.38,1.42v-1.92c-.29.07-.57.15-.86.21-.02,1.81-.19,1.89-2.22,2.58-.03.01-.08-.02-.16-.03-.02-.17-.06-.34-.04-.52.04-.54.08-1.07.11-1.61-.29.04-.58.07-.87.11-.03.23-.06.46-.12.69-.36,1.47-.48,3.33-2.7,3.62.14-1.36.27-2.72.41-4.09-.25.01-.5.02-.75.03-.15,1.03-.29,2.06-.39,3.1-.08.9-.19,1.35-1.2,1.49-1.11.15-2.18.58-3.15.86.09-1.89.26-3.76.26-5.63,0-.13.01-.26.01-.39-.25-.1-.49-.21-.72-.33-.03,1.07-.06,2.14-.11,3.21-.05,1.04-.34,2.08-.6,3.1-.06.24-.41.5-.68.58-1.39.4-2.79.77-4.2,1.09-.59.13-1.08-.06-.91-.85.23-1.1.56-2.19.67-3.3.21-2.25.35-4.5.52-6.75-.31-.01-.62-.03-.93-.06-.25,3.71-.19,7.4-1.46,10.8h-5.08v-5.34c-.89,1.57-1.65,3.21-1.07,5.15-.98-.05-1.85-.09-2.74-.14.23-1.62.46-3.16.68-4.7-.15-.03-.31-.05-.46-.08-.46,1.5-.92,3.01-1.37,4.47-.73-.09-1.42-.17-1.99-.23.33-2.31.67-4.64,1.01-6.99-.26-.07-.52-.15-.79-.24-.03-.01-.06-.03-.1-.04-.36,2.35-.69,4.72-1.05,7.25-1.04-.78-1.91-1.44-2.73-2.06.55-2.11,1.1-4.22,1.66-6.35-.26-.19-.51-.38-.76-.58-.58,2.3-1.17,4.59-1.76,6.89-.6-.3-.98-.49-1.38-.69.22-1.19.37-2.39.2-3.57-.2,0-.4,0-.6,0-.1,1.12-.2,2.25-.32,3.62-.83-.37-1.53-.63-2.16-1.01-.25-.15-.45-.62-.42-.92.09-.82.29-1.64.48-2.45.37-1.63.96-3.23,1.1-4.88.01-.14.04-.28.05-.42-.29-.16-.57-.32-.87-.46-.56,2.69-1.04,5.41-1.57,8.17-.73-.35-1.23-.58-1.74-.83.56-2.71,1.12-5.4,1.68-8.07-.27-.11-.53-.22-.8-.33-.53,2.52-1.06,5.05-1.64,7.84-1.22-1-2.19-1.79-3.2-2.63.4-.27.72-.37.8-.56.67-1.63,1.39-3.24,1.9-4.92.06-.19.11-.38.16-.57-.35-.19-.67-.41-.95-.66-.64,2.02-1.28,4.04-1.92,6.06-.23-.02-.47-.05-.7-.07-.11-.7-.38-1.44-.4-2.12-.41.35-.87.64-1.37.84-.1.91-.21,1.82-.3,2.73-.02.18-.06.34-.09.52.33.84,1.03,1.54,1.31,2.39.07.2.19.42.36.54,2.75,2.04,5.31,4.25,8.65,5.56,3.62,1.41,7.31,1.59,11.02,2.01,2.17.24,4.39.04,6.55.33,3.7.51,7.27-.19,10.83-.9,3.06-.61,5.95-1.69,8.59-3.47.89-.6,2.23-.48,3.34-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m111.03,17.12c.34,1.21.37,2.51.59,3.76.15.82.4,1.62.61,2.44,1.31.43,2.62.89,3.91,1.39-1.08-2.12-1.07-4.48-1.17-6.8-.29-.24-.58-.48-.87-.72.13.86.15,1.76.08,2.67-.11,1.42.27,2.45.66,3.63.08.23.11.47.19.8-1.75-.57-2.27-1.89-2.54-3.38-.27-1.51-.35-3.08-.81-4.52-.35-1.09-1.18-2.02-1.8-3.03-.15.07-.29.14-.44.21.1.38.13.78.3,1.12.41.82,1.05,1.57,1.3,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.21,25.55c.4.17.8.33,1.19.5-.66-2.02-1.26-3.86-1.9-5.83,2.01.36,3.22,4.31,3.16,6.38.35.15.69.3,1.04.45-.34-.88-.45-1.91-.2-3.17.82,1.45,1.59,2.8,2.33,4.12,1.48.66,2.97,1.31,4.46,1.95-.25-.88-.45-1.81-.79-2.55-2.86-1.98-5.63-4.13-8.44-6.3-.9-.69-1.8-1.38-2.7-2.08.19.56.37,1.13.53,1.7.44,1.55.85,3.11,1.31,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m110.77,22.85c.43.13.85.28,1.28.42-1.14-.79-2.22-1.53-3.23-2.23-.2-3.16-.4-6.32-.61-9.75-.29-.33-.59-.65-.9-.96.09.28.14.6.13.96,0,.38,0,.77-.03,1.15-.08.86-.35,1.75-.25,2.59.21,1.79.61,3.55.93,5.33-.15.04-.31.08-.46.13-1.1-.77-2.63-.92-2.79-2.86-.23-2.71-.13-5.49-1.27-8.07-.18-.4-.22-.87-.29-1.43-.18-.02-.35-.03-.54-.02-.06,0-.11,0-.17,0,.59,3.56,1.17,7.12,1.76,10.68-.14.1-.28.2-.42.31-.66-.38-1.52-.62-1.93-1.18-.37-.49-.28-1.35-.33-2.05-.11-1.78-.13-3.56-.3-5.34-.08-.88-.2-1.75-.06-2.58-.27-.07-.53-.16-.77-.26-.09.49-.23.98-.2,1.47.14,2.36.33,4.72.53,7.08.06.68.19,1.36.3,2.11-1.39-.38-2.12-1.46-2.19-3.06-.13-3.09-.57-6.13-1.48-9.09-.16.36-.35.7-.59,1.01.24,1.02.55,2.02.7,3.05.38,2.47.66,4.96.98,7.41-1.29.11-1.96-.4-2.06-1.79-.1-1.4-.42-2.78-.67-4.16-.19-1.06-.39-2.12-.58-3.18-.29.16-.59.29-.89.39.05.35.11.7.22,1.04.73,2.29.89,4.77,1.3,7.16-.19.1-.38.2-.57.3-.4-.5-1-.94-1.18-1.51-.56-1.8-.91-3.67-1.43-5.49-.13-.44-.27-.88-.41-1.32-.04,0-.07,0-.11,0-.29-.04-.58-.11-.86-.2,0,.02,0,.03.01.05.69,2.63,1.35,5.27,2.05,7.99h-2.42c-.62-3.4-1.78-6.69-2.39-10.14-.02-.04-.04-.07-.06-.11-.11-.24-.23-.47-.36-.69-.25-.19-.49-.52-.71-.76.11.75.24,1.49.4,2.23.5,2.31,1.21,4.58,1.86,6.86.66,2.3.54,2.66-1.28,3.1-.17-.48-.39-.96-.5-1.46-.42-1.98-.72-4-1.22-5.96-.5-1.94-1.05-3.87-1.61-5.8-.32.09-.67.15-1.03.17.83,2.95,1.68,5.89,2.49,8.85.35,1.29.52,2.63.77,3.92h-2.62c.13-.06.26-.11.38-.17-.49-1.84-.98-3.68-1.46-5.52-.06.47-.21.91-.42,1.33.34,1.49.69,2.99,1.06,4.58-.47.04-1.01.09-1.57.14,0,.04-.01.07-.02.11,2.88.25,5.14.69,7.12,2.19,2.62-.16,5.23.34,7.81.94,1.37.32,2.81.37,4.21.56.3.04.62.09.89.23,1.33.66,2.67,1.29,4.02,1.92,1.05-.76,2.43-1.08,4.07-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.83,51.28c-.25-.05-.61.15-.79.03-1.02-.67-1.98-1.43-3-2.1-.46-.3-1.02-.44-1.51-.7-.76-.42-1.7-.72-2.22-1.35-1.66-2.02-3.78-3.17-6.08-4.02-2.72-.14-5.44-.22-8.09-.79-.11.23-.41.4-.91.52-1.18.29-2.77.11-2.57,2.32-2.06-1.13-3.37-.06-4.97.98-1.62,1.05-2.69,2.13-3.17,3.97-.21.82-.84,1.53-1.29,2.28-.69,1.16-1.48,2.29-2.03,3.51-.13.28.23.77.49,1.22.48-.21.99-.36,1.5-.43.01-.02.04-.04.06-.06.74-1.64,1.24-3.38,1.97-5.01.2-.44.89-.69,1.38-.96.3-.16.75-.11.98-.31,1.74-1.54,3.39-3.19,5.2-4.64.64-.51,1.63-.61,2.47-.82,2.24-.54,4.51-1.02,6.68.17,1.5.82,2.96,1.75,4.37,2.71,1.57,1.07,3.11,2,5.02,2.5,1.87.49,3.59,1.57,5.34,2.45.21.11.41.79.29.93-1.74,2.01-3.56,3.85-6.14,4.89-1.39.56-2.53,1.75-3.77,2.67-1.14.85-2.25,1.74-3.4,2.57-1.3.94-.62,1.99-.16,2.96.48,1.02,1.47.88,2.38.76,1.5-.21,3-.42,4.5-.63.07.19.14.37.21.56-.83.71-1.69,1.39-2.48,2.14-2.58,2.44-5.64,4.02-8.82,5.34-.17.2-.36.39-.58.58-1.52,1.29-3.08,2.75-4.81,3.8-.21.2-.41.41-.61.62.07.11.14.21.2.32-.19,2.15-.65,4.19-2.26,5.82-.64-.68-1.1-1.37-1.35-2.04,0,0,0,0,0,0-1.07,1.53-2.08,3.05-3.06,4.59.97,1.18,1.84,2.28,2.79,3.3.15.16.88.03,1.13-.19,2.03-1.85,4.02-3.73,4.68-6.58.34-1.47.99-2.88,1.3-4.36.27-1.3,1.26-1.63,2.21-2.1,3.76-1.86,7.54-3.73,10.66-6.58,2.12-1.94,4.12-4.02,6.1-6.1.32-.34.43-1.08.32-1.56-.07-.27-.83-.61-1.2-.53-1.19.26-2.34.71-3.51,1.07-.31.1-.66.28-.95.21-.97-.21-1.92-.5-2.97-.79,2.2-1.91,3.87-4.47,6.67-5.92,2.2-1.14,4.29-2.59,5.46-4.92.26-.51.38-1.42.1-1.78-.3-.39-1.15-.4-1.77-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65,14.4c-.49-1.37-.95-2.75-1.5-4.1-.66-1.63-1.4-3.23-2.09-4.85-.42-.99-.3-1.74.78-2.32.97-.52,1.3-1.84.77-2.57-.67-.93-1.53-.5-2.42-.32-3.89.79-6.79,3.5-10.21,5.18-.16.08-.3.21-.41.34-2.31,2.79-5.45,4.73-7.21,8.14-2.39,4.62-5.21,9.03-7.45,13.74-1.2,2.51-2.29,5.07-3.4,7.62.09.03.18.05.27.08,1.23.03,2.42-.16,3.58-.52.2-.42.4-.86.61-1.32.1.36.2.68.29,1,.27-.11.54-.22.81-.34-.07-.14-.15-.27-.25-.36-.97-.82-.96-1.67-.28-2.77.4.96.78,1.9,1.16,2.83.28-.14.55-.28.83-.43-.59-1.25-1.17-2.51-1.77-3.78,1.2.76,2.2,2.03,2.72,3.23.54-.33,1.07-.67,1.59-1.02-.33-.77-.66-1.53-.96-2.27-.36-.89-.64-1.83-1.01-2.72-.62-1.5-.52-1.85.76-2.67.83,2.16,1.68,4.35,2.52,6.55.01-.33.06-.66.13-.98-.11-.5-.15-1.01-.12-1.52-.61-1.79-1.23-3.61-1.87-5.49.93-1.22,1.98-2.6,3.03-3.99.41.89.8,1.75,1.19,2.58.17-.21.35-.42.56-.6-.11-.27-.21-.54-.29-.81-.21-.66-.28-1.37-.42-2.06-.19-.05-.38-.11-.58-.16.58-.56,1.16-1.12,2.06-1.99.38,1.35.69,2.69,1.02,3.99.25-.07.51-.14.78-.17-.35-1.42-.69-2.86-1.05-4.38.15-.2.46-.61.98-1.32.62,1.56,1.22,3.07,1.81,4.56.2-.18.41-.34.64-.5-.59-1.5-1.16-3.03-1.79-4.67.22-.4.58-1.04,1.08-1.95.78,1.98,1.55,3.94,2.32,5.87.31-.08.63-.12.95-.13-.44-1.21-.89-2.41-1.42-3.57-.78-1.71-1.48-3.17.12-4.71.06-.06.13-.12.33-.29.61,3.18,1.81,6.11,3.08,9.01.47.21.91.48,1.31.82-1.34-3-2.79-5.97-3.32-9.27-.17-1.07-.37-2.15,1.2-2.55,1.54,3.98,3.09,7.97,4.64,11.97.22-.23.45-.44.71-.62-1.59-4.09-3.16-8.14-4.76-12.28.63-.41,1.54-1,2.51-1.63,1.49,4.38,2.95,8.65,4.4,12.92.3-.08.6-.14.91-.18-.38.05-.04,0,.27-.06-.03-.07-.04-.14-.07-.2-2.32-3.75-2.87-8.09-4.34-12.24h1.29c.42,1.14.77,2.19,1.2,3.2.7,1.66,1.51,3.28,2.18,4.95.52,1.3,1.03,2.6,1.54,3.91.16-.05.4-.12.63-.19-.17-.54-.34-1.07-.53-1.6Zm-25.25,15.95c-.56-.51-.95-.93-1.4-1.28-1.02-.77-1.04-1.24.06-2.46.47,1.3.88,2.46,1.34,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.74,100.19c-.03.13-.05.26-.07.38-.52,2.3-1.09,4.56-.47,6.93.51-2.52.73-5.1,1.14-7.64-.2.11-.4.22-.59.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.48,99.51c-.49,2.56-.98,5.1-1.46,7.56.03.04-.12-.16-.45-.57-.04.6-.18.99-.06,1.25.24.52.62.96.94,1.44.21-.52.54-1.03.62-1.57.28-1.97.43-3.97.73-5.94.1-.65.26-1.3.42-1.95-.05-.08-.09-.18-.13-.26-.2,0-.41.02-.61.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.91,61.6c-1.85-.35-3.49-.73-5.15-.95-3.02-.41-6.05-.73-9.08-1.1-.2-.02-.38-.12-.58-.18,0-.12-.02-.24-.03-.36.94-.18,1.88-.51,2.81-.49,1.11.02,2.22.19,3.34.32-.21-.19-.4-.4-.56-.62-.4-.03-.79-.05-1.19-.09-2.82-.22-5.95-.5-7.4,2.27-.06.12-.13.22-.19.33-.08.41-.14.83-.17,1.26-.02.34.48.78.82,1.08.75.65,1.56,1.24,2.16,1.71,1.35.25,2.48.45,3.6.68.29.06.57.3.83.28,1.85-.14,3.7-.33,5.55-.5,1.14-.1,2.28-.22,3.43-.28,1.46-.07,2.19-.96,1.94-2.43-.07-.43-.11-.86-.12-.93Zm-14.03-1.06c3.64.28,6.92.53,10.22.79-3.07,1.55-8.24.9-10.22-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.72,36.86c-1.08-1.08-2.13-2.22-3.39-3.02-2.57-1.62-5.41-2.69-8.43-3.19-1.63-.27-3.54,1.04-3.75,2.52,1.87,1.32,4.03.8,6.06,1.13,2,.32,3.95,1.07,5.85,1.83,1.29.52,2.47,1.33,3.88,2.14-.16-.47-.22-.94-.21-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.79,43.83c-.74-.12-1.31-1.24-1.68-1.63.03-2.29.79-3.89,1.6-3.92,1.1-.04,3.24,1.83,3.25,2.84.01,1.32-1.64,2.96-3.17,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.98,36.84h0s.08.1.11.16c-.04-.06-.07-.11-.11-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.36,37.75c2.93,1.18,5.85,2.39,8.75,3.62.2.08.26.48.46.9-.49,0-.83.1-1.08-.02-.8-.37-1.54-.89-2.36-1.22-2.84-1.15-5.69-2.25-8.55-3.35-.97-.37-1.95-.76-2.96-1-1.44-.35-2.92-.56-4.37-.87-.14-.03-.25-.22-.36-.39-.04-.06-.07-.11-.11-.16.08-.06.17-.14.26-.21.08-.07.17-.12.23-.11,1.93.38,3.88.71,5.78,1.22,1.47.4,2.89,1.01,4.3,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.14,76.9c-.67.48-1.64.69-2.49.73-1.12.05-2.08-.65-2.07-1.77,0-.78.54-1.73,1.14-2.28.54-.49,1.49-.54,2.34-.8,1.05,1.03,1.81,3.59,1.08,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.12,62.64c-.96.02-2.81-1.66-2.87-2.63-.07-1.16,1.2-2.28,2.7-2.37.84-.05,1.88.93,1.85,1.92-.04,1.35-.57,3.06-1.68,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.51,66.66c.03-.38.15-.78.35-1.1.61-.99,1.49-.52,2.29-.32,1.13.29,1.18,1.18,1.11,1.99,0,2.02-.25,2.42-1.69,2.76-1.06.25-2.14-.51-2.08-1.42.04-.63-.04-1.27.02-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.32,53.22c-.72.47-1.27.62-1.83-.11-.57-.72-1.43-1.26-.84-2.48.73-1.53,2.17-1.63,3.43-2.11,1.29,1.49.88,3.64-.75,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.41,52.56c-3.39.08-6.77.13-10.19-.51.23.26.44.71.7.73,2.02.23,4.05.38,6.08.54.34.03.68.01,1.02.01,2.16,0,4.32.02,6.48,0-1.37-.2-2.73-.47-4.09-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.07,39.33c.29.09.54.29.82.4,1.04.42,2.05.99,3.13,1.2,1.77.36,2.86,1.1,2.98,2.6-.42-.25-.82-.36-1.02-.62-.74-.94-1.81-.94-2.84-1.17-.92-.21-1.78-.67-2.64-1.07-.41-.19-.73-.58-1.15-.71-2.22-.68-4.47-1.29-6.69-1.98-.5-.16-.93-.54-1.39-.83.09-.14.18-.28.26-.41.13-.02.27-.09.38-.05,2.72.87,5.44,1.76,8.15,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.23,32.33c-.42-.24-.81-.64-1.26-.73-1.02-.21-.98-1.01-.71-1.53.4-.75,1.05-1.79,1.72-1.88,1.32-.19,2.52,1.4,2.51,2.84-.02,1.82-.67,2.2-2.26,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.85,56.45c.42-.11,1.29.06,1.34.27.25.91-.55.62-1.02.7-.17.03-.34.11-.51.15-4.02.75-8.05,1.38-12.17,1.2-1.04-.05-1.64-.36-1.32-1.39,1.15.21,2.17.57,3.19.54,3.54-.11,7.05-.53,10.49-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.56,54.27c1.47.5,2.88.72,4.5.52,2.98-.36,6-.33,9.01-.44.37-.01.75.18,1.12.27-.33.21-.63.57-.98.6-1.59.17-3.2.21-4.8.36-3.19.29-6.38.53-9.65-.8.27-.18.61-.58.8-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.28,76.83c-.77-.13-1.94-1.22-1.91-1.84.05-.95.98-1.86,1.57-2.83,1.38,1.02,2.99,1.61,2.47,3.3-.2.66-1.49,1.48-2.13,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.43,50.07c-.1,1.25-1,1.49-2.06,1.76-.27-.14-.75-.22-.84-.45-.29-.77-.57-1.59-.62-2.4-.05-.88,1.28-2.17,1.92-2.07,1,.16,1.72,1.63,1.59,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.67,75.59c-.24,0-.62-.2-.7-.41-.28-.68-.75-1.47-.61-2.1.18-.79.81-1.52,1.42-2.11.12-.12,1.16.41,1.48.86.76,1.06.73,2.29.18,3.54-.64.09-1.21.21-1.77.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.84,58.96c.02.97-.67,1.5-1.44,1.63-1.15.2-2.55-1.01-2.61-2.5.39-.52.84-1.55,1.63-2.06.64-.41,2.39,1.77,2.42,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.12,98.45c-.11-.08-.22-.14-.33-.22-.25,1.06-.45,2.13-.55,3.23.29-.99.61-1.98.95-2.96-.02-.02-.04-.03-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.38,22.49c-.05-.09-.1-.18-.12-.28-.3-1.37-.46-1.46-1.83-.88.16.81.27,1.53.44,2.23.08.32.3.87.42.86.21-.02.44-.07.65-.16.03-.62.18-1.21.43-1.77Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenPiggvar);
export default __webpack_public_path__ + "static/media/hidden-piggvar.74042482eeaa8c2447eae4b3ce3f5e20.svg";
export { ForwardRef as ReactComponent };